import React from "react";

const IndustrialAlliances = () => {
    const firstRow = [
        "nasscom.svg",
        "xebia.svg",
        "tcs2.svg",
        "ambuja.svg",
    ];

    const secondRow = [
        "amcat.svg",
        "cocubes.svg",
        "startupindia.svg",
        "wondercement.svg",
        "cdc.svg",
    ];

    // const cardStyle = {
    //     background: "#fff",
    //     borderRadius: "14px",
    //     boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
    //     padding: "20px 25px",
    //     width: "180px",
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    // };

    return (
        <section className="py-lg-5 py-4"
            style={{
                background: "linear-gradient(180deg, #FFFFFF  100%, #FEF6F6 0%)",
                position: "relative",
            }}
        >
            {/* Dotted Background */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "radial-gradient(rgba(180,1,3,0.15) 1px, transparent 1px)",
                    backgroundSize: "22px 22px",
                    opacity: 0.4,
                }}
            />

            <div className="container text-center" style={{ position: "relative", zIndex: 2 }}>
                {/* Heading */}
                <h2 className="sub_heading text-center mb-0" style={{ fontWeight: "700" }}>
                    Industrial <span style={{
                        background: "linear-gradient(90deg, #4E0001 , #B40103 )",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent", fontWeight: "500", padding: "12px 0px"
                    }}>Alliances</span>
                </h2>

                <p style={{
                    background: "linear-gradient(90deg, #B40103, #4E0001)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent", fontWeight: "500", padding: "12px 0px"
                }} className="mb-0 text-center">
                    Get Future-Ready With our Top Industry Collaborations and Think Beyond Learning. We have alliances with:
                </p>

                {/* First Row - 4 Logos */}
                <div
                    className="d-flex flex-wrap justify-content-center gap-4 my-4"
                >
                    {firstRow.map((logo, index) => (
                        <div key={index} className="alliances-logo-main">
                            <img
                                src={`/images/${logo}`}
                                alt="logo"
                                style={{ width: "100%", objectFit: "contain" }}
                            />
                        </div>
                    ))}
                </div>

                {/* Second Row - 5 Logos */}
                <div
                    className="d-flex flex-wrap justify-content-center gap-4"
                >
                    {secondRow.map((logo, index) => (
                        <div className="alliances-logo-main" key={index}>
                            <img
                                src={`/images/${logo}`}
                                alt="logo"
                                style={{ width: "100%", objectFit: "contain" }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default IndustrialAlliances;